export default __webpack_public_path__ + "static/grid2022_hero-57409c15a0e054a0da960f8b089a0bad.jpg";